import React, {useState, useEffect} from 'react';
import NoData from "../../Driveanalysis_Bus/NoData_Bus";
// import COmpBiDirTest from '../../Faultanalysis_Bus/FaultFirstPage_Bus/FaultSecondPageChartsBidirRender_Bus';
// import COmpBiDirTest from '../../Faultanalysis_Bus/FaultFirstPage_Bus/FaultSecondPageChartsBidirRender_Bus';
import ChartLoader from "../../Driveanalysis_Bus/ChartLoader";
import useHttp from "../../../../hook/use-http";
import { API_URL_MAIN } from "../../../../constants/driveglobalfilterinitalstates_bus";
import * as $ from "jquery";
import COmpBiDirTest from "./FaultSecondPageChartsBidirRender_Bus";

export default function FaultSecondGraph(props) {

  let responceDataImbData = [];
  let responceDataSocImbData = [];

    const { isLoading, error, sendReq: fetchData } = useHttp();
    let { title, template_id, show, soarting, gloablfilter, IND } = props;

    const [topping, setTopping] = useState("Fault");
    const [activePage, setActivePage] = useState(0);
    const [defaultNav, setDefaultNav] = useState("BCS-1");
    const [LineContainerBodyBD, setCssLineCont] = useState({ height: "268px" });
    const [dataMain, setDataMain] = useState([]);
    const [single_name, setsingle_name] = useState([]);
    const [toCalculateFault, setToCalculateFault] = useState(0);
    const [ECUData, setECUData] = useState({});
    const [ECUAlarmData, setECUAlarmData] = useState({});
    const [IMBActive, setIMBActive] = useState(0);

    const [responceDataImbDataImb, setresponceDataImbData] = useState([]);
    const [responceDataSocImbDataImb, setresponceDataSocImbData] = useState([]);

    const onRadioChange = async (e) =>{
      await setTempData([])
      if(e.target.value === 'Alarm' && defaultNav === 'sp'){
          $("#sp").removeClass("active");
          $("#BCS-1").addClass("active");
          setDefaultNav('BCS-1')
          setDataMain([])
      }
      if(e.target.value === 'IMB'){
        setTopping('IMB')
        // setDefaultNav('BCS-1')
        setDefaultNav('CurrImb')
        responceDataImb(responceDataImbDataImb)
        setToCalculateFault("")
        // imbfunc(gloablfilter)
      }
      if((e.target.value === 'Fault' || e.target.value === 'Alarm') && (defaultNav === 'CurrImb' || defaultNav === 'SocImb')){
        // setDataMain([])
        setDefaultNav("BCS-1")
      }
      await setTopping(e.target.value)
    }

    function getNavTab(e, name) {
        setDefaultNav(name);
        if(name === 'SocImb'){
          $("#CurrImb").removeClass("active");
          $("#SocImb").addClass("active");
          setDefaultNav('SocImb')
          responceDataSocImb(responceDataSocImbDataImb)
        }
        if(name === 'CurrImb'){
          $("#SocImb").removeClass("active");
          $("#CurrImb").addClass("active");
          setDefaultNav('CurrImb')
          responceDataImb(responceDataImbDataImb)
        }
    }

    const ecuFaultResponse = (data) =>{
        const ecuDict = {};
        data.forEach((item) => {
            const ecu = item.key.ECU;
            const vehicleCount = item.vehicle_count.value;
            ecuDict[ecu] = vehicleCount;
        });
        setECUData(ecuDict)
    }

    const ecuAlarmResponse = (data) =>{
      const ecuDict = {};
      data.forEach((item) => {
          const ecu = item.key.ECU;
          const vehicleCount = item.vehicle_count.value;
          ecuDict[ecu] = vehicleCount;
      });
      setECUAlarmData(ecuDict)
    }

    useEffect(() =>{
      setDefaultNav("BCS-1")
        fetchData(
            {
              url: API_URL_MAIN + "faultfirstpage_bus/faultanalysis_bus",
              body: { filterdata: gloablfilter, IND },
            },
            ecuFaultResponse
        );

        fetchData(
          {
            url: API_URL_MAIN + "faultfirstpage_bus/alarmanalysis_bus",
            body: { filterdata: gloablfilter, IND },
          },
          ecuAlarmResponse
        );
    }, [gloablfilter])

    useEffect(() =>{
        if (Object.keys(ECUData).length !== 0) {
            fetchData(
                {
                  url: API_URL_MAIN + "faultfirstpage_bus/vehicleLevalBusFault",
                  body: { filterdata: gloablfilter, IND, defaultNav: "BCS-1" },
                },
                responceBarData
            );
        }
    }, [ECUData])

    const deno = async (data, defaultNav) => {
      if(topping === 'Fault' && defaultNav !== 'sp'){
        if (ECUData.hasOwnProperty(defaultNav)) {
          await setTempData(data)
          await setToCalculateFault(ECUData[defaultNav]);
          // await setDataMain([])
          // await setTempData(data)
        } else {
          await setToCalculateFault(0);
        }
      } else if(topping === 'Alarm') {
        if (ECUAlarmData.hasOwnProperty(defaultNav)) {
          await setTempData(data)
          await setToCalculateFault(ECUAlarmData[defaultNav]);
          // await setDataMain([])
          // await setTempData(data)
        } else {
          await setToCalculateFault(0);
        }
      }
      if(topping === 'Fault' && defaultNav === 'sp'){
        if (ECUData.hasOwnProperty("BMS")) {
          await setTempData(data)
          await setToCalculateFault(ECUData["BMS"]);
        } else {
          await setToCalculateFault(0);
        }
      }
    };

    useEffect(() => {
      if(toCalculateFault !== ""){
        // if(topping === 'Fault' && defaultNav === 'sp'){
        //   if (ECUData.hasOwnProperty("BMS")) {
        //     setToCalculateFault(ECUData["BMS"]);
        //   } else {
        //     setToCalculateFault(0);
        //   }
        // }
        const data = TempData
        let dataArray = [];
        let maleAdd = 0;
        let femaleAdd = toCalculateFault;
        data.forEach((obj1, index) => {
          maleAdd += obj1.duration.value;
        });

        let single_name_array = [];
        data.forEach((obj1, index) => {
          let male = (obj1.duration.value / maleAdd) * 100;
          let female = (obj1.Total_vehicle_count.value / femaleAdd) * 100;
          dataArray.push({
            age: obj1.key.spnname.toUpperCase(),
            male: -male,
            female: female,
            orgLevalMale: obj1.duration.value.toFixed(0).toString(),
            orgLevalFemale: obj1.Total_vehicle_count.value.toString(),
            signal_nm: obj1.key.spnname,
            signal_desc: obj1.key.Description,
            signal_val: obj1.key.spnvalue.toString(),
          });
          single_name_array.push(obj1.key.spnname);
        });
    
        setsingle_name(single_name_array);
        for (let i = 0; i < dataArray.length; i++) {
          let count = 0;
          for (let j = i + 1; j < dataArray.length; j++) {
            if (dataArray[i].age === dataArray[j].age) {
              dataArray[j].age = dataArray[j].age + "_" + dataArray[j].signal_val;
              count = 1;
            }
          }
          if (count) {
            dataArray[i].age = dataArray[i].age + "_" + dataArray[i].signal_val;
          }
        }
        dataArray.sort((a, b) => parseFloat(a.male) - parseFloat(b.male));
        setDataMain(dataArray);
      }
    }, [toCalculateFault])
    
    
    const [TempData, setTempData] = useState([])
    const responceBarData = (data) => {
      // setTempData(data)
      setTempData([])
      setDataMain([])
      deno(data, defaultNav);
    };

  useEffect(() =>{
    if(topping !== 'IMB'){
      // setTempData([])
      // setDataMain([])
      if (Object.keys(ECUData).length !== 0) {
          fetchData(
              {
                url: API_URL_MAIN + "faultfirstpage_bus/vehicleLevalBus" + topping,
                body: { filterdata: gloablfilter, IND, defaultNav: defaultNav },
              },
              responceBarData
          );
      }
    }

  }, [defaultNav,topping, gloablfilter])
  
  const renderTabContent = (tabId) => {
      return (
        <div
          id={tabId}
          className={`tab-pane ${(defaultNav === tabId) ? 'active' : ''}`}
        >
          <br />
          <div
            style={{
              width: 'auto',
              maxWidth: 'auto',
              overflowX: 'scroll',
              overflowY: 'scroll',
            }}
          >
            <div style={LineContainerBodyBD}>
              {isLoading ? (
                <ChartLoader />
              ) : dataMain.length > 0 ? (
                <COmpBiDirTest
                  dataMain={dataMain}
                  id={`chartdiv${tabId}`}
                  type={topping}
                  unit={defaultNav}
                  gloablfilter={gloablfilter}
                  signal_name={single_name}
                />
              ) : (
                <NoData />
              )}
            </div>
          </div>
        </div>
      );
  };

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "faultfirstpage_bus/faulwithdtc_bus",
        body: { filterdata: gloablfilter },
      },
      vehicleWithDtc
    );
    fetchData(
      {
        url: API_URL_MAIN + "faultfirstpage_bus/vehicleLevalBusImb_A",
        body: { filterdata: gloablfilter, IND, defaultNav: defaultNav },
      },
      responceDataImb_A
    );
    fetchData(
      {
        url: API_URL_MAIN + "faultfirstpage_bus/vehicleLevalBusImb_B",
        body: { filterdata: gloablfilter, IND, defaultNav: defaultNav },
      },
      responceDataImb_B
    );
    fetchData(
      {
        url: API_URL_MAIN + "faultfirstpage_bus/vehicleLevalBusImb_C",
        body: { filterdata: gloablfilter, IND, defaultNav: defaultNav },
      },
      responceDataImb_C
    );
    fetchData(
      {
        url: API_URL_MAIN + "faultfirstpage_bus/vehicleLevalBusImb_D",
        body: { filterdata: gloablfilter, IND, defaultNav: defaultNav },
      },
      responceDataImb_D
    );
  }, [gloablfilter]);

  const [vehiclewithdtc, setVehicleWithDtc] = useState(0);
  let responceDataImbDataA = [];
  let responceDataImbDataB = [];
  let responceDataImbDataC = [];
  let responceDataImbDataD = [];

  const vehicleWithDtc = (data) => {
    setVehicleWithDtc(data[0].vehicle_count.value);
  };

  const responceDataImb_A = (dataimba) => {
    const data = dataimba[0];
    responceDataImbDataA.push({
      duration: data.duration_A.value,
      vehicle_count: data.vehicle_count.value,
      spnname: "A_pack",
    });
    responceDataImbData.push(responceDataImbDataA[0]);
  };

  const responceDataImb_B = (dataimbb) => {
    const data = dataimbb[0];
    responceDataImbDataB.push({
      duration: data.duration_B.value,
      vehicle_count: data.vehicle_count.value,
      spnname: "B_pack",
    });
    responceDataImbData.push(responceDataImbDataB[0]);
  };

  const responceDataImb_C = (dataimbc) => {
    const data = dataimbc[0];
    responceDataImbDataC.push({
      duration: data.duration_C.value,
      vehicle_count: data.vehicle_count.value,
      spnname: "C_pack",
    });
    responceDataImbData.push(responceDataImbDataC[0]);
  };

  const responceDataImb_D = (dataimbd) => {
    const data = dataimbd[0];

    // setToCalculateFault(data.vehicle_count.value);
    responceDataImbDataD.push({
      duration: data.duration_D.value,
      vehicle_count: data.vehicle_count.value,
      spnname: "D_pack",
    });
    responceDataImbData.push(responceDataImbDataD[0]);

    setresponceDataImbData(responceDataImbData);
    // responceDataImb(responceDataImbData);
  };

  const responceDataImb = (responceDataImbDataImb) => {
    let dataArray = [];
    let maleAdd = 0;
    let femaleAdd = 0;
    responceDataImbDataImb.forEach((obj1, index) => {
      maleAdd += obj1.duration;
      femaleAdd += obj1.vehicle_count;
    });
    responceDataImbDataImb.forEach((obj1, index) => {

      let male = (obj1.duration / maleAdd) * 100;
      let female = (obj1.vehicle_count / vehiclewithdtc) * 100;
      dataArray.push({
        age: obj1.spnname.toUpperCase(),
        male: -male,
        female: female,
        orgLevalMale: obj1.duration.toFixed(0).toString(),
        orgLevalFemale: obj1.vehicle_count.toString(),
        signal_nm: obj1.spnname,
      });
    });

    for (let i = 0; i < dataArray.length; i++) {
      let count = 0;
      for (let j = i + 1; j < dataArray.length; j++) {
        if (dataArray[i].age === dataArray[j].age) {
          dataArray[j].age = dataArray[j].age + "_" + dataArray[j].signal_val;
          count = 1;
        }
      }
      if (count) {
        dataArray[i].age = dataArray[i].age + "_" + dataArray[i].signal_val;
      }
    }

    dataArray.sort((a, b) => parseFloat(a.male) - parseFloat(b.male));
    setDataMain(dataArray);
  };

  useEffect(() =>{
    if(topping === 'IMB' && defaultNav==="CurrImb")
    {
      (responceDataImbDataImb.length > 0 ) && responceDataImb(responceDataImbDataImb)
    }
  },[responceDataImbDataImb])


  const [vehiclewithSocImb, setVehicleWithSocImb] = useState(0);
  let responceDataSocImbDataA = [];
  let responceDataSocImbDataB = [];
  let responceDataSocImbDataC = [];
  let responceDataSocImbDataD = [];

  const vehicleWithSocImb = async (data) => {
    await setVehicleWithSocImb(data[0].vehicleId_count.value);
  };

  const responceDataSocImb_A = async(datasocimba) => {
    const data = datasocimba[0];

    await responceDataSocImbDataA.push({
      duration: data.A_pack_soc_duration.value,
      vehicle_count: data.vehicleId_count.value,
      spnname: "A_pack",
    });
    await responceDataSocImbData.push(responceDataSocImbDataA[0]);
  };

  const responceDataSocImb_B = async(datasocimba) => {
    const data = datasocimba[0];
    await responceDataSocImbDataB.push({
      duration: data.B_pack_soc_duration.value,
      vehicle_count: data.vehicleId_count.value,
      spnname: "B_pack",
    });
    await responceDataSocImbData.push(responceDataSocImbDataB[0]);
  };

  const responceDataSocImb_C = async(datasocimba) => {
    const data = datasocimba[0];
    await responceDataSocImbDataC.push({
      duration: data.C_pack_soc_duration.value,
      vehicle_count: data.vehicleId_count.value,
      spnname: "C_pack",
    });
    await responceDataSocImbData.push(responceDataSocImbDataC[0]);
  };

  const responceDataSocImb_D = async(dataimbd) => {
    const data = dataimbd[0];

    await responceDataSocImbDataD.push({
      duration: data.D_pack_soc_duration.value,
      vehicle_count: data.vehicleId_count.value,
      spnname: "D_pack",
    });
    await responceDataSocImbData.push(responceDataSocImbDataD[0]);
    await setresponceDataSocImbData(responceDataSocImbData);
  };

  const fetchDataAndUpdateAll = async (gloablfilter) => {
    await fetchData({url : API_URL_MAIN + "faultfirstpage_bus/faulwithSocImb_bus", body : { filterdata: gloablfilter },}, vehicleWithSocImb);
    await fetchData({url : API_URL_MAIN + "faultfirstpage_bus/vehicleLevalBusSocImb", body : { filterdata: gloablfilter, IND, TextPack: "A" },}, responceDataSocImb_A);
    await fetchData({url : API_URL_MAIN + "faultfirstpage_bus/vehicleLevalBusSocImb", body : { filterdata: gloablfilter, IND, TextPack: "B" },}, responceDataSocImb_B);
    await fetchData({url : API_URL_MAIN + "faultfirstpage_bus/vehicleLevalBusSocImb", body : { filterdata: gloablfilter, IND, TextPack: "C" },}, responceDataSocImb_C);
    await fetchData({url : API_URL_MAIN + "faultfirstpage_bus/vehicleLevalBusSocImb", body : { filterdata: gloablfilter, IND, TextPack: "D" },}, responceDataSocImb_D);
  };

  useEffect(() => {
    fetchDataAndUpdateAll(gloablfilter);
    // fetchData(
    //   {
    //     url: API_URL_MAIN + "faultfirstpage_bus/faulwithSocImb_bus",
    //     body: { filterdata: gloablfilter },
    //   },
    //   vehicleWithSocImb
    // );
    // fetchData(
    //   {
    //     url: API_URL_MAIN + "faultfirstpage_bus/vehicleLevalBusSocImb",
    //     body: { filterdata: gloablfilter, IND, TextPack: "A" },
    //   },
    //   responceDataSocImb_A
    // );
    // fetchData(
    //   {
    //     url: API_URL_MAIN + "faultfirstpage_bus/vehicleLevalBusSocImb",
    //     body: { filterdata: gloablfilter, IND, TextPack: "B" },
    //   },
    //   responceDataSocImb_B
    // );
    // fetchData(
    //   {
    //     url: API_URL_MAIN + "faultfirstpage_bus/vehicleLevalBusSocImb",
    //     body: { filterdata: gloablfilter, IND, TextPack: "C" },
    //   },
    //   responceDataSocImb_C
    // );
    // fetchData(
    //   {
    //     url: API_URL_MAIN + "faultfirstpage_bus/vehicleLevalBusSocImb",
    //     body: { filterdata: gloablfilter, IND, TextPack: "D" },
    //   },
    //   responceDataSocImb_D
    // );
  }, [gloablfilter]);

  const responceDataSocImb = (responceDataSocImbDataImb) => {
    let dataArray = [];
    let maleAdd = 0;
    let femaleAdd = 0;
    responceDataSocImbDataImb.forEach((obj1, index) => {
      maleAdd += obj1.duration;
      femaleAdd += obj1.vehicle_count;
    });
    responceDataSocImbDataImb.forEach((obj1, index) => {

      let male = (obj1.duration / maleAdd) * 100;
      let female = (obj1.vehicle_count / vehiclewithSocImb) * 100;
      dataArray.push({
        age: obj1.spnname.toUpperCase(),
        male: -male,
        female: female,
        orgLevalMale: obj1.duration.toFixed(0).toString(),
        orgLevalFemale: obj1.vehicle_count.toString(),
        signal_nm: obj1.spnname,
      });
    });

    for (let i = 0; i < dataArray.length; i++) {
      let count = 0;
      for (let j = i + 1; j < dataArray.length; j++) {
        if (dataArray[i].age === dataArray[j].age) {
          dataArray[j].age = dataArray[j].age + "_" + dataArray[j].signal_val;
          count = 1;
        }
      }
      if (count) {
        dataArray[i].age = dataArray[i].age + "_" + dataArray[i].signal_val;
      }
    }

    dataArray.sort((a, b) => parseFloat(a.male) - parseFloat(b.male));
    setDataMain(dataArray);
  };

  useEffect(()=>{
    if(topping==='IMB' && defaultNav ==='SocImb')
    (responceDataSocImbDataImb.length >0 ) && responceDataSocImb(responceDataSocImbDataImb);
  },[responceDataSocImbDataImb])
  
  return (
    <div className="col-md-12 col-lg-6 col-sm-12 mb-3">
      <div className="v-title chartbox3">
        <div className="row mb-3 titlebg_bus_fault">
          <div className="col-md-12 col-sm-6 col-lg-6">
            <div className="text-fit">Fault/Alarm/Imbalance List</div>
          </div>
          <div className="col-md-12 col-sm-6 col-lg-6 py-1">
            <div className="form-check form-check-inline bus">
              <input
                className="form-check-input"
                type="radio"
                name="inlineRadioOptions"
                id="Fault"
                value="Fault"
                checked={topping === "Fault"}
                onChange={onRadioChange}
              />
              <label className="form-check-label" htmlFor="inlineRadio1">
                Fault
              </label>
            </div>
            <div className="form-check form-check-inline bus">
              <input
                className="form-check-input"
                type="radio"
                name="inlineRadioOptions"
                id="Alarm"
                value="Alarm"
                checked={topping === "Alarm"}
                onChange={onRadioChange}
              />
              <label className="form-check-label" htmlFor="inlineRadio2">
                Alarm
              </label>
            </div>
            <div className="form-check form-check-inline bus">
              <input
                className="form-check-input "
                type="radio"
                name="inlineRadioOptions"
                id="IMB"
                value="IMB"
                checked={topping === "IMB"}
                onChange={onRadioChange}
              />
              <label className="form-check-label" htmlFor="inlineRadio2">
                Imbalance
              </label>
            </div>
          </div>
        </div>

        {topping === "Fault" || topping === "Alarm" ? (
          <div className="chartHGT">
            <div className="mt-2 mb-2">
              <div className="mt-3">
                <ul className="nav nav-tabs" role="tablist" style={{ marginBottom: "5px" }}>
                  <li className="nav-item" style={{ width: "57px" }}>
                    <a
                      // className={
                      //   activePage === 1 ? "nav-link" : "nav-link active"
                      // }
                      style={{paddingLeft:"12px", paddingRight:"5px"}}
                      className={
                        (defaultNav === "BCS-1") ? "nav-link active" : "nav-link"
                      }
                      // className="nav-link active"
                      data-bs-toggle="tab"
                      href="#BCS-1"
                      id="BCS-1"
                      onClick={(e) => getNavTab(e, "BCS-1")}
                    >
                      BCS-1
                    </a>
                  </li>
                  <li className="nav-item" style={{ width: "57px" }}>
                    <a
                      // className="nav-link"
                      style={{paddingLeft:"12px", paddingRight:"5px"}}
                      className={
                        (defaultNav === "BCS-2") ? "nav-link active" : "nav-link"
                      }
                      data-bs-toggle="tab"
                      href="#BCS-2"
                      onClick={(e) => getNavTab(e, "BCS-2")}
                    >
                      BCS-2
                    </a>
                  </li>
                  <li className="nav-item" style={{ width: "57px" }}>
                    <a
                      // className="nav-link"
                      style={{textAlign:"center", justifyContent:"center"}}
                      className={
                        (defaultNav === "MCU") ? "nav-link active" : "nav-link"
                      }
                      data-bs-toggle="tab"
                      href="#MCU"
                      onClick={(e) => getNavTab(e, "MCU")}
                    >
                      MCU
                    </a>
                  </li>
                  <li className="nav-item" style={{ width: "57px" }}>
                    <a
                      // className="nav-link"
                      style={{textAlign:"center", justifyContent:"center"}}
                      className={
                        (defaultNav === "VCU") ? "nav-link active" : "nav-link"
                      }
                      data-bs-toggle="tab"
                      href="#VCU"
                      onClick={(e) => getNavTab(e, "VCU")}
                    >
                      VCU
                    </a>
                  </li>
                  <li className="nav-item" style={{ width: "57px" }}>
                    <a
                      // className="nav-link"
                      style={{paddingLeft:"12px", paddingRight:"5px"}}
                      className={
                        (defaultNav === "Aux-1") ? "nav-link active" : "nav-link"
                      }
                      data-bs-toggle="tab"
                      href="#Aux-1"
                      onClick={(e) => getNavTab(e, "Aux-1")}
                    >
                      Aux-1
                    </a>
                  </li>
                  <li className="nav-item" style={{ width: "57px" }}>
                    <a
                      // className="nav-link"
                      style={{paddingLeft:"12px", paddingRight:"5px"}}
                      className={
                        (defaultNav === "Aux-2") ? "nav-link active" : "nav-link"
                      }
                      data-bs-toggle="tab"
                      href="#Aux-2"
                      onClick={(e) => getNavTab(e, "Aux-2")}
                    >
                      Aux-2
                    </a>
                  </li>
                  <li className="nav-item" style={{ width: "57px" }}>
                    <a
                      // className="nav-link"
                      style={{textAlign:"center", justifyContent:"center"}}
                      className={
                        (defaultNav === "BMS") ? "nav-link active" : "nav-link"
                      }
                      data-bs-toggle="tab"
                      href="#BMS"
                      onClick={(e) => getNavTab(e, "BMS")}
                    >
                      BMS
                    </a>
                  </li>
                  <li className="nav-item" style={{ width: "57px" }}>
                    <a
                      // className="nav-link"
                      style={{paddingLeft:"12px", paddingRight:"5px"}}
                      className={
                        (defaultNav === "HVAC") ? "nav-link active" : "nav-link"
                      }
                      data-bs-toggle="tab"
                      href="#HVAC"
                      onClick={(e) => getNavTab(e, "HVAC")}
                    >
                      HVAC
                    </a>
                  </li>
                  {topping === "Fault" ? (
                    <>
                    <li className="nav-item" style={{ width: "57px" }}>
                      <a
                        // className="nav-link"
                        style={{paddingLeft:"12px", paddingRight:"5px"}}
                        className={
                          (defaultNav === "DC-DC") ? "nav-link active" : "nav-link"
                        }
                        data-bs-toggle="tab"
                        href="#DC-DC"
                        onClick={(e) => getNavTab(e, "DC-DC")}
                      >
                        DC-DC
                      </a>
                    </li>
                    <li className="nav-item" style={{ width: "57px" }}>
                      <a
                        // className="nav-link"
                        style={{textAlign:"center", justifyContent:"center"}}
                        className={
                          (defaultNav === "sp") ? "nav-link active" : "nav-link"
                        }
                        data-bs-toggle="tab"
                        href="#sp"
                        onClick={(e) => getNavTab(e, "sp")}
                      >
                        Critical
                      </a>
                    </li>
                    
                    </>
                    
                  ) : (
                    <></>
                  )}
                </ul>
                <div className="tab-content">
                  <div className="row" style={{ textAlign: "right" }}>
                    <dl style={{ marginBottom: "0rem", paddingRight: "3rem" }}>
                      <dt className="red_bus"></dt>
                      <dd>Time Duration (mins)</dd>
                      <dt
                        className="yellow_bus"
                        style={{ marginLeft: "5px" }}
                      ></dt>
                      <dd>Vehicle Count</dd>
                    </dl>
                  </div>
                {renderTabContent('BCS-1')}
                {renderTabContent('BCS-2')}
                {renderTabContent('MCU')}
                {renderTabContent('VCU')}
                {renderTabContent('Aux-1')}
                {renderTabContent('Aux-2')}
                {renderTabContent('BMS')}
                {renderTabContent('HVAC')}
                {renderTabContent('DC-DC')}
                {topping === 'Fault' ? renderTabContent('sp') : null}
                  {/* {topping === "Fault" ? (
                    <div id="sp" className="container tab-pane fade">
                      <br />
                      <div
                        style={{
                          width: "auto",
                          maxWidth: "auto",
                          overflowX: "scroll",
                          overflowY: "scroll",
                        }}
                      >
                        <div style={LineContainerBodyBD}>
                          {isLoading ? (
                            <ChartLoader />
                          ) : dataMain.length > 0 ? (
                            <COmpBiDirTest
                              dataMain={dataMain}
                              id={"chartdivsp"}
                              type={topping}
                              unit={defaultNav}
                              gloablfilter={gloablfilter}
                              signal_name={single_name}
                            />
                          ) : (
                            <NoData />
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )} */}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}

        {topping === "IMB" ? (
          <div className="chartHGT">
            <div className="mt-2 mb-2">
              <div className="mt-3">
                <ul
                  className="nav nav-tabs"
                  role="tablist"
                  style={{ marginBottom: "5px" }}
                >
                  <li className="nav-item">
                    <a
                      className="nav-link active"
                      data-bs-toggle="tab"
                      href="#CurrImb"
                      id='CurrImb'
                      onClick={(e) => getNavTab(e, "CurrImb")}
                    >
                      Curr. Imbalance
                    </a>
                  </li>
                  <div style={{paddingRight:"10px"}}></div>
                  <li className="nav-item">
                    <a
                      className="nav-link "
                      data-bs-toggle="tab"
                      href="#SocImb"
                      id='SocImb'
                      onClick={(e) => getNavTab(e, "SocImb")}
                    >
                      SOC. Imbalance
                    </a>
                  </li>
                </ul>
                <div className="tab-content">
                  <div className="row" style={{ textAlign: "right" }}>
                    <dl style={{ marginBottom: "0rem", paddingRight: "3rem" }}>
                      <dt className="red_bus"></dt>
                      <dd>Time Duration (mins)</dd>
                      <dt
                        className="yellow_bus"
                        style={{ marginLeft: "5px" }}
                      ></dt>
                      <dd>Vehicle Count</dd>
                    </dl>
                  </div>
                  <div id="Imb" className="tab-pane active">
                    <br />
                    <div
                      style={{
                        width: "auto",
                        maxWidth: "auto",
                        overflowX: "scroll",
                        overflowY: "scroll",
                      }}
                    >
                      <div style={LineContainerBodyBD}>
                        {isLoading ? (
                          <ChartLoader />
                        ) : dataMain.length > 0 ? (
                          <COmpBiDirTest
                            dataMain={dataMain}
                            id={`chartdiv${defaultNav}`}
                            type={topping}
                            unit={defaultNav}
                            gloablfilter={gloablfilter}
                            signal_name={single_name}
                            // `chartdiv${tabId}`
                          />
                        ) : (
                          <NoData />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  )
}
